import { render, staticRenderFns } from "./StylistOrders.vue?vue&type=template&id=3e06e665"
import script from "./StylistOrders.vue?vue&type=script&lang=js"
export * from "./StylistOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports